exports.components = {
  "component---src-builder-io-page-js": () => import("./../../../src/builder-io/page.js" /* webpackChunkName: "component---src-builder-io-page-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dealers-js": () => import("./../../../src/pages/dealers.js" /* webpackChunkName: "component---src-pages-dealers-js" */)
}

